// ProtectedRoute.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, permissionKey }) => {
  const token = localStorage.getItem("token");

  const apiResponse = useSelector((state) => state.login.login.role);
  // console.log("apiResponse: in dashboard content ", apiResponse);
  const permissions = apiResponse || {};
  // console.log("permissions: ", permissions);

  // Check if the user is authenticated
  if (!token) {
    return <Navigate to="/login" />;
  }

  // Check if the required permission exists and has read access
  const hasPermission = permissions[permissionKey]?.read === 1;

  // Redirect to home or another safe route if the user does not have permission
  if (!hasPermission) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
